import { render } from "./NewTextToolModal.vue?vue&type=template&id=92105830"
import script from "./NewTextToolModal.vue?vue&type=script&lang=js"
export * from "./NewTextToolModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__